import React from "react";
import "./Header.css";
import { useLocation, useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // const goToHome = () => {
  //     navigate('/');
  //   };
  const goTo = (path) => {
    navigate(path);
  };

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <header className="header">
      {/* <div className="social-icons">
        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-facebook-f"></i>
        </a>
        <a
          href="https://www.instagram.com/makeup_by_priyapratap?igsh=cHZiY2t2djh4eGds"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-instagram"></i>
        </a>
        <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-youtube"></i>
        </a>
      </div> */}
      <div className="logo">PRIYA PRATAP MAKEUP STUDIO</div>
      <nav className="nav-links">
        {/* <a onClick={goToHome} href="">Home</a>
        <a href="" className="active">Portfolio</a>
        <a href="">Nail Art</a>
        <a href="">Academy</a>
        <a href="">Prices</a>
        <a href="">Studio</a>
        <a href="">About</a>
        <a href="">Contact</a> */}
        <a onClick={() => goTo('/')} className={isActive('/')}>Home</a>
        <a onClick={() => goTo('/portfolio')} className={isActive('/portfolio')}>Portfolio</a>
        <a onClick={() => goTo('/nail-art')} className={isActive('/nail-art')}>Nail Art</a>
        <a 
        onClick={() => goTo('/academy')}
        className={isActive('/academy')}>Academy</a>
        {/* <a 
        // onClick={() => goTo('/prices')} 
        className={isActive('/prices')}>Prices</a> */}
        <a 
        onClick={() => goTo('/studio')}
         className={isActive('/studio')}>Studio</a>
        <a 
        onClick={() => goTo('/about-us')} 
        className={isActive('/about-us')}>About Us</a>
        {/* <a 
        // onClick={() => goTo('/contact')} 
        onClick={() => goTo('/contact-us')} 
        className={isActive('/contact')}>Contact</a> */}
      </nav>
    </header>
  );
};

export default Header;
